import Vue, { PluginObject } from "vue"
// @ts-ignore
import Cookies from "js-cookie"

export interface CookieConfig {
    necessaryCookies: boolean
    analyticsCookies: boolean
}

export interface CookieConsentData {
    config: CookieConfig
    consentedAt: null | Date
}

const COOKIE_CONSENT_KEY = "cookie_consent"

export class CookieConsentService {
    private consentData: CookieConsentData

    public getConsentData(): CookieConsentData {
        return this.consentData
    }

    get hasConsented() {
        return this.consentData.consentedAt !== null
    }

    public hasConsentTo(key: "necessaryCookies" | "analyticsCookies"): boolean {
        if (!Object.prototype.hasOwnProperty.call(this.consentData.config, key)) {
            return false
        }

        return this.consentData.config[key]
    }

    public constructor() {
        let data: CookieConsentData | null = null

        if (Cookies.get(COOKIE_CONSENT_KEY) !== undefined) {
            try {
                data = JSON.parse(<string>Cookies.get(COOKIE_CONSENT_KEY))
            } catch (exception) {
                Cookies.remove(COOKIE_CONSENT_KEY)
            }
        }

        if (!data) {
            data = {
                config: {
                    necessaryCookies: true,
                    analyticsCookies: false,
                },
                consentedAt: null,
            }
        }

        this.consentData = Vue.observable(data)
    }

    public updateConsent(config: CookieConfig) {
        const newConsent: CookieConsentData = {
            config: config,
            consentedAt: new Date(),
        }

        const expirationDate = new Date()
        expirationDate.setFullYear(expirationDate.getFullYear() + 1)

        Cookies.set(COOKIE_CONSENT_KEY, JSON.stringify(newConsent), {
            expires: expirationDate,
        })

        this.consentData.consentedAt = newConsent.consentedAt
        this.consentData.config = newConsent.config
    }
}

const CookieConsentPlugin: PluginObject<any> = {
    install: (Vue) => {
        Vue.prototype.$cookieConsent = new CookieConsentService()
    },
}

export default CookieConsentPlugin
